import { Component } from '@angular/core';

@Component({
    selector: 'app-cookies',
    templateUrl: './cookies.component.html',
    standalone: false,
})
export class CookiesComponent {

}
